import React from 'react';
import PropTypes from 'prop-types';
import ToggleSwitch from '@trendmicro/react-toggle-switch';

export default function Amenities({
  values, onChange, errors, amenities,
}) {
  return (
    <div className="business amenities-container">
      <div className="business__row amenities">
        <p className="business__row__label">Is your Practice or Office disabled friendly?</p>
        <div
          className="business__row__input"
          style={{ textAlign: 'right', marginBottom: 30 }}
        >
          <ToggleSwitch
            checked={!!values.amenities_disabled_friendly_available}
            onChange={() => {
              onChange({
                target: {
                  name: 'amenities_disabled_friendly_available',
                  value: !values.amenities_disabled_friendly_available,
                },
              });
            }}
          />
        </div>
      </div>

      <div className="business__row amenities">
        <p className="business__row__label">Do you offer gas anesthesia to ease anxiety?</p>
        <div
          className="business__row__input"
          style={{ textAlign: 'right', marginBottom: 30 }}
        >
          <ToggleSwitch
            checked={!!values.amenities_gas_anesthetic_available}
            onChange={() => {
              onChange({
                target: {
                  name: 'amenities_gas_anesthetic_available',
                  value: !values.amenities_gas_anesthetic_available,
                },
              });
            }}
          />
        </div>
      </div>
    </div>
  );
}

Amenities.defaultProps = {
  onChange: () => { },
  values: {},
  errors: {},
};

Amenities.propTypes = {
  onChange: PropTypes.func,
  values: PropTypes.shape(),
  errors: PropTypes.shape(),
};
